import { useLocation, Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

export function RequireAuth({ children, allowedRoles }) {
  const location = useLocation();
  const { route, user } = useAuthenticator((context) => [context.route, context.user]);
  
  if (route !== 'authenticated') {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  const userRole = user?.attributes?.["custom:user_type"];
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // Redirect to a "not authorized" page or a safe default
    return <Navigate to="/home" replace />;
  }

  return children;
}